import { Reveal, SectionEyebrow } from "./Reveal";
import { IMAGES, VAN_BENEFITS } from "../../data";
import { CheckCircle2 } from "lucide-react";

export const WhyVans = () => (
  <section className="bg-white py-20 md:py-28" data-testid="why-vans">
    <div className="container-oyf grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
      <Reveal className="order-2 lg:order-1">
        <div className="relative rounded-lg overflow-hidden border-[6px] border-oyf-black yellow-shadow">
          <img src={IMAGES.vanSecondary} alt="White cargo van ready for right-sized expedited delivery" className="w-full h-[340px] md:h-[460px] object-cover" />
        </div>
      </Reveal>
      <div className="order-1 lg:order-2">
        <SectionEyebrow>Right-Sized Expedited Transportation</SectionEyebrow>
        <h2 className="font-display font-extrabold text-oyf-black tracking-tight text-3xl md:text-5xl leading-[1.02]">
          Why Use a Cargo Van Instead of a Full-Size Truck?
        </h2>
        <p className="mt-5 text-oyf-medgrey text-base md:text-lg leading-relaxed">
          Many commercial shipments are urgent but do not require the capacity of a tractor-trailer. Cargo vans and Sprinter vans can provide a faster, more flexible and appropriately sized solution for smaller freight.
        </p>
        <div className="mt-8 grid sm:grid-cols-2 gap-5">
          {VAN_BENEFITS.map((b, i) => (
            <Reveal key={b.t} delay={i * 0.08}>
              <div className="border-l-2 border-oyf-yellow pl-4">
                <h3 className="font-display font-bold text-oyf-black text-lg">{b.t}</h3>
                <p className="text-sm text-oyf-medgrey mt-1.5 leading-relaxed">{b.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <div className="mt-8 flex gap-3 bg-oyf-grey rounded-lg p-5">
          <CheckCircle2 size={20} className="text-oyf-charcoal shrink-0 mt-0.5" />
          <p className="text-sm text-oyf-charcoal leading-relaxed">
            Depending on the vehicle, route, weight, cargo and jurisdiction, cargo-van operations may involve fewer requirements than heavy-truck transportation. Each shipment and business operation must still follow all applicable laws, permits, insurance conditions and border requirements.
          </p>
        </div>
      </div>
    </div>
  </section>
);
